/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Heading, HFlow, Icon, Text, Theme, useTheme, VFlow } from 'bold-ui'
import { HLabel } from 'components/HLabel'
import { useServerTime } from 'hooks/useServerTime'

import { RegulacaoEvolucaoModel, StatusRegulacaoEnumMap } from '../../model-regulacao'
import { formatDateHistoricoRegulacao } from '../../utils-regulacao'

interface HistoricoRegulacaoEvolucaoItemProps {
  item: RegulacaoEvolucaoModel
  showConnector: boolean
}

export function HistoricoRegulacaoEvolucaoItem(props: Readonly<HistoricoRegulacaoEvolucaoItemProps>) {
  const { item, showConnector } = props

  const theme = useTheme()
  const { getServerTimeNow } = useServerTime()
  const { color, icon, text } = StatusRegulacaoEnumMap[item.statusRegulacao]
  const styles = createStyles(theme, color)
  const formattedDate = formatDateHistoricoRegulacao(item.dataEvolucao, getServerTimeNow())

  return (
    <HFlow style={styles.root} hSpacing={0.5}>
      <Icon icon={icon} color={color} />
      {showConnector && <span css={styles.connector} />}
      <VFlow vSpacing={0}>
        <HFlow hSpacing={0.25}>
          <Heading level={4} style={styles.heading}>
            {text}
          </Heading>
          <Text style={styles.date}>| Atualizado {formattedDate}</Text>
        </HFlow>
        <HLabel title='Observações:'>{item.observacao}</HLabel>
      </VFlow>
    </HFlow>
  )
}

const createStyles = (theme: Theme, color: string) => ({
  root: css`
    position: relative;
  `,
  heading: css`
    color: ${color};
  `,
  date: css`
    color: ${theme.pallete.gray.c40};
  `,
  connector: css`
    z-index: 1;
    height: calc(100% - 16px);
    position: absolute;
    top: 24px;
    left: 11px;
    border-left-width: 2px;
    border-left-style: solid;
    border-left-color: ${theme.pallete.gray.c80};
  `,
})
